import {
    mapValues,
    findKey,
    get,
    sortBy
} from 'lodash';

import { getLegalStatusApi } from '../../apis/core_basic_api/legal_status_config';
import { legalSettings } from '@patsnap-utils/biz';
import { proxyDefaultValue } from '../../componentZPrefaceProxy/proxyDefaultValue';

const backendFieldsMap = {
    'LEGAL_STATUS': 'legalStatus',
    'SIMPLE_LEGAL_STATUS': 'simpleLegalStatus',
    'LEGAL_EVENT': 'legalEvents'
};

// 兼容移除zPREFACE
let legalConfig;

export const getLegalConfig = () => {
    return legalConfig || proxyDefaultValue.legalConfig;
};

export const setLegalConfig = (config) => {
    legalConfig = config;
};

export async function initLegalStatus() {
    const legalConfig = getLegalConfig();
    if (legalConfig && legalConfig.length) {
        return { legalConfig };
    }
    try {
        const legalStatusConfig = await getLegalStatusApi();
        let result = [];
        mapValues(legalStatusConfig, (value, key) => {
            mapValues(value, (codeValue, code) => {
                result.push(
                    {
                        codeType: findKey(backendFieldsMap, o => o === key),
                        label: get(codeValue, 'title', {}),
                        color: get(codeValue, 'color', ''),
                        desc: get(codeValue, 'desc', {}),
                        isEpStatus: get(codeValue, 'ep_code', false),
                        epLabel: get(codeValue, 'ep_legal_group_title', {}),
                        epDesc: get(codeValue, 'ep_legal_group_desc', {}),
                        relatedCode: get(codeValue, 'related_code', []),
                        code,
                    });
            });
        });
        try {
            // 不知为什么会出错
            legalSettings(document, result);
        } catch (err) {
            console.error(err);
        }
        // 排序是为了确保simple legal status在legal status后面

        const config = sortBy(result, 'codeType');
        setLegalConfig(config);

        return {
            legalConfig: config,
        };
    } catch (err) {
        throw err;
    }

}
